import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../utils/cn';
import { styles } from './LinkBox.styles';
export const LinkBox = ({ className, As = 'div', ...props }) => {
    return _jsx("div", { className: cn(styles.root, className), ...props });
};
export const LinkOverlay = ({ className, As = 'a', children, ...props }) => (_jsxs(_Fragment, { children: [_jsx(As, { className: cn(styles.overlay, className), ...props }), children] }));
